import styled from '@emotion/styled';
import { type FC, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTrackersForAction } from '../../../lib/customHooks';
import { AddTrackerToEvent } from '../AddTrackerToEvent/AddTrackerToEvent';

export const AddTrackerToEventButton: FC = () => {
  const [show, setShow] = useState(false);
  const trackersToUse = useTrackersForAction();

  if (trackersToUse == null) return <></>;

  return (
    <>
      <Container onClick={() => setShow(true)}>
        <div>Add tracker to event</div>
      </Container>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add tracker to an event</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <AddTrackerToEvent
            trackerIds={trackersToUse.map((t) => t.id)}
            onAddToEvent={() => setShow(false)}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
